import React from "react";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Home from "./pages/Home";
import News from "./pages/News";
import Products from "./pages/ProductsAll";
import Recruitment from "./pages/Recruitment";

import {BrowserRouter as Router, Routes, Route,} from "react-router-dom";
import { CategoryProducts } from "./pages/CategoryProducts";
import SingleProduct from "./pages/SingleProduct";
import Header from "./components/Header";
import Footer from "./components/Footer";
import NewsEvent from "./pages/NewsEvent";
import JobDetails from "./pages/JobDetails";
import './PageCss/style.css';
import NotFound from "./pages/NotFound";
import { useAappContext } from "./context/AppContext";






function App() {
const{Avansis}=useAappContext()

 if(Avansis.length === 0){
<div style={{
    minHeight:'100vh',
    display:'flex',
    justifyContent:"center",
    alignItems:"center",
    fontSize:18,
    color:"green",
              }}>
    ..........Loading
  </div>
 }
  return (
    <div className="App">
      <Router>
              <Header/>
      <Routes>
      <Route path="/" element={<Home />}/>
      <Route path="/aboutus" element={<AboutUs />}/>
      {/* <Route path="/product/?=id:productid" element ={<SingleProduct />}/> */}
      <Route path="/product/:product_id" element ={<SingleProduct />}/>
      <Route path="/products" element={<Products/>}/>
      <Route path="products/:category" element={<CategoryProducts />}/>
      <Route path="news" element={<News />}/>
      <Route path="news/:ne_id" element={<NewsEvent />}/>
      <Route path="recruitsment" element={<Recruitment />}/>
      <Route path="contactus" element={<ContactUs />}/>
      <Route path="jobdetails/:job_id" element={<JobDetails/>} />

      <Route path="*" element={<NotFound/>} />
      </Routes>
              <Footer/>
      </Router>
    </div>
  );
}

export default App;
